module.exports = __webpack_public_path__ + "img/icon-about.b6f0c101.svg";